// extracted by mini-css-extract-plugin
export default {"CreateBranch__Field--normal":"CreateBranch_CreateBranch__Field--normal__Qh8F2","CreateBranch__Field--spaced":"CreateBranch_CreateBranch__Field--spaced__BWObo"};